import { Box, Flex } from '@chakra-ui/react';
import {
  floatFormatter,
  intCurrencyFormatter,
} from 'src/components/molecules/DataTable/cellFuncs';
import { Optimization } from 'src/features/MO/types';
import { useCurrency } from 'src/hooks/useCurrency';
import { useTableEffectFormatter } from 'src/hooks/useEffectFormatter';

// eslint-disable-next-line no-restricted-imports
import { Icon as ChakraIcon } from '@chakra-ui/react';
import { ChevronDown, ChevronRight } from 'lucide-react';

type OptimizationRowProps = {
  optimization: Optimization;
  isExpanded: boolean;
};

export const OptimizationRow: React.FC<OptimizationRowProps> = ({
  optimization,
  isExpanded,
}) => {
  const effectFormatter = useTableEffectFormatter();
  const { code: currencyCode } = useCurrency();
  const investmentFormatter = intCurrencyFormatter(currencyCode);

  return (
    <Flex
      textAlign={{ lg: 'right', xl: 'left' }}
      overflowWrap="anywhere"
      flex={1}
      flexDir="row"
      wrap="nowrap"
      minW="fit-content">
      <Box
        width="15%"
        minW="140px"
        p={4}
        // textAlign={{ lg: 'right', xl: 'left' }}
        fontSize={{ md: 'xs', lg: 'sm' }}
        fontFamily="marketingPage"
        color="content.title"
        textAlign="left">
        <ChakraIcon
          as={isExpanded ? ChevronDown : ChevronRight}
          boxSize={4}
          mr={2}
          display="inline-block"
          verticalAlign="middle"
          w={4}
          minW={4}
        />
        {optimization.optimizationName}
      </Box>
      <Box
        width="20%"
        minW="180px"
        p={4}
        textAlign={{ lg: 'right', xl: 'left' }}
        fontSize={{ md: 'xs', lg: 'sm' }}
        fontFamily="marketingPage"
        color="content.title">{`${optimization.period.from.format(
        'YYYY-MM-DD',
      )} - ${optimization.period.to.format('YYYY-MM-DD')}`}</Box>
      <Box
        width="15%"
        minW="110px"
        p={4}
        textAlign={{ lg: 'right', xl: 'left' }}
        fontSize={{ md: 'xs', lg: 'sm' }}
        fontFamily="marketingPage"
        color="content.title">
        {investmentFormatter(optimization.optimizedInvestmentSum)}
      </Box>
      <Box
        width="15%"
        minW="110px"
        p={4}
        textAlign={{ lg: 'right', xl: 'left' }}
        fontSize={{ md: 'xs', lg: 'sm' }}
        fontFamily="marketingPage"
        color="content.title">
        {effectFormatter(optimization.optimizedEffectSum)}
      </Box>
      {optimization.totalRomi && (
        <Box
          width={{ base: '50%', md: '10%' }}
          minW={{ base: '60px', md: 'auto' }}
          p={4}
          textAlign={{ lg: 'right', xl: 'left' }}
          fontSize={{ md: 'xs', lg: 'sm' }}
          fontFamily="marketingPage"
          color="content.title">
          {floatFormatter(optimization.totalRomi.optimized)}
        </Box>
      )}
      <Box
        width="10%"
        minW="80px"
        p={4}
        textAlign={{ lg: 'right', xl: 'left' }}
        fontSize={{ md: 'xs', lg: 'sm' }}
        fontFamily="marketingPage"
        color="content.title">
        {floatFormatter(optimization.totalRoi.optimized)}
      </Box>
      <Box
        width="10%"
        minW="120px"
        p={4}
        textAlign={{ lg: 'right', xl: 'left' }}
        fontSize={{ md: 'xs', lg: 'sm' }}
        fontFamily="marketingPage"
        color="content.title">
        {optimization.constraints.length}
      </Box>
    </Flex>
  );
};
